package com.eladfinish.bible.contest.screens.misc.ui

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.rememberUpdatedState
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.platform.LocalUriHandler
import androidx.compose.ui.tooling.preview.Preview
import com.eladfinish.bible.contest.analytics.crashlytics.AppCrashlytics
import com.eladfinish.bible.contest.screens.misc.MiscAction
import com.eladfinish.bible.contest.screens.misc.MiscEffect
import com.eladfinish.bible.contest.screens.misc.MiscStore
import com.eladfinish.bible.contest.screens.misc.miscLinkItems
import com.eladfinish.bible.contest.ui.common.VerticalSpacer
import com.eladfinish.bible.contest.ui.components.buttons.ItemButtonText
import com.eladfinish.bible.contest.ui.components.verticalScrollWithScrollbar
import com.eladfinish.bible.contest.ui.extensions.navigationBarInsetPadding
import kotlinx.coroutines.flow.Flow
import org.koin.compose.viewmodel.koinViewModel

@Composable
fun MiscScreen(
    logEvent: (String) -> Unit,
    onNavigateToSeminar: () -> Unit,
    showToast: (String) -> Unit,
    miscStore: MiscStore = koinViewModel(),
) {
    val currentOnNavigateToSeminar by rememberUpdatedState(onNavigateToSeminar)
    val currentShowToast by rememberUpdatedState(showToast)

    MiscSideEffectsCollector(
        effects = miscStore.observeSideEffect(),
        onNavigateToSeminar = { currentOnNavigateToSeminar() },
        onShowMessage = { currentShowToast(it) },
    )

    Column(
        modifier = Modifier
            .fillMaxWidth()
            .verticalScrollWithScrollbar()
            .navigationBarInsetPadding(),
        horizontalAlignment = Alignment.CenterHorizontally,
        verticalArrangement = Arrangement.Center,
    ) {
        val uriHandler = LocalUriHandler.current

        VerticalSpacer()

        miscLinkItems.forEach {
            MiscButtonText(
                text = it.text,
                onClick = {
                    logEvent(it.text)
                    try {
                        uriHandler.openUri(it.link)
                    } catch (e: Exception) {
                        AppCrashlytics.logException(e)
                    }
                }
            )
        }

        val text = """משחק ליום עיון"""
        MiscButtonText(
            text = text,
            onClick = {
                logEvent(text)
                miscStore.dispatch(MiscAction.SeminarClicked)
            }
        )
    }
}

@Composable
private fun MiscSideEffectsCollector(
    effects: Flow<MiscEffect>,
    onNavigateToSeminar: () -> Unit,
    onShowMessage: (String) -> Unit,
) {
    val currentOnNavigateToSeminar by rememberUpdatedState(onNavigateToSeminar)
    val currentOnShowMessage by rememberUpdatedState(onShowMessage)

    LaunchedEffect(Unit) {
        effects.collect { effect ->
            when (effect) {
                MiscEffect.NavigateToSeminar -> currentOnNavigateToSeminar()
                is MiscEffect.ShowMessage -> currentOnShowMessage(effect.text)
            }
        }
    }
}

@Composable
fun MiscButtonText(
    text: String,
    onClick: () -> Unit,
) {
    ItemButtonText(
        text = text,
        borderWidth = 0,
        onClick = onClick,
    )
}

@Preview
@Composable
private fun MiscScreenPreview() {
    MiscScreen(
        logEvent = {},
        onNavigateToSeminar = {},
        showToast = {},
    )
}
